import React, {Component, createRef} from "react";
import DataTable from './TableBase';
import {withRouter} from "react-router-dom";
import MainHelper, {formattedPrice} from "../../helpers/MainHelper";
import withPermissions from "../WithPermissions";
class ApproachingDebtsTable extends Component{

    constructor(props) {
        super(props);
        this.tableRef = createRef();
        this.state = {
            pending:true
        }

    }
    triggerFetch = (page = 1, size = 10, search = '') => {
        if (this.tableRef.current) {
            this.tableRef.current.fetchData(page, size, search);
        }
    };
    handleReceivableDetail = (receiveId) => {
        this.props.history.push(`/receivable-supplier-detail/${receiveId}`);
    }
    render() {
        const {pending} = this.state;
        const {userPermissions} = this.props;
        const userHasViewReceivablePermission = userPermissions.includes('view receivable');
        const columns = [
            {
                name:'ID',
                selector:row => row.receivable_id,
                sortable:true
            },
            {
                name:'Fatura No',
                selector:row => row.e_invoice_id || row.invoice_no || "Fatura bulunamadı",
                sortable:true
            },
            {
                name:'Tedarikçi',
                selector:row => row.name.toUpperCase()+' '+(row.surname?.toUpperCase() || ''),
                sortable:true
            },
            {
                name:'Son Ödeme Tarihi',
                selector:row => MainHelper.dateFormat(row.due_date).split(' 0')[0]
            },
            {
                name: 'Toplam Tutar',
                selector: row => formattedPrice(Number(row.total_amount || 0))
            },
            {
                name: 'Kalan Tutar',
                selector: row => formattedPrice(Number(row.remaining_amount || 0))
            },



        ]
        return (
            <DataTable
                ref={this.tableRef}
                dataEndpoint={"business/reports/approaching-debts"}
                columns={columns}
                onRowClicked={userHasViewReceivablePermission ? row => this.handleReceivableDetail(row.receivable_id) : undefined}
                progressPending={pending}>
            </DataTable>
        )
    }

}
export default withPermissions(withRouter(ApproachingDebtsTable));
